import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Home, Info, Hammer, Recycle, Phone } from "lucide-react";
import HomeIcon from "@mui/icons-material/Home";
import "./header.css";
// import logo from '../../../src/Assets/navbar/logo.svg';
// import rightarrow from '../../../src/Assets/navbar/right-arrow.svg';
// import bras from '../../../src/Assets/navbar/bras.svg';
// import cancel from '../../../src/Assets/navbar/cancel.svg';

function Navbar({ onAboutClick, onHomeClick }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const navigate = useNavigate();
  const closeSidebar = () => setOpen(false);

  const handleAboutClick = () => {
    if (location.pathname === "/") {
      onAboutClick(); // Already on Home → scroll directly
    } else {
      // Navigate to Home and pass scroll target in state
      navigate("/", { state: { scrollTo: "about" } });
    }
  };

  const handleHomeClick = () => {
    if (location.pathname === "/") {
      onHomeClick(); // Already on Home → scroll directly
    } else {
      // Navigate to Home and pass scroll target in state
      navigate("/", { state: { scrollTo: "home" } });
    }
  };

  const menuItems = [
    {
      label: "Home",
      icon: (
        <Home className="w-[5vw] h-[5vw] md:w-[1.2vw] md:h-[1.2vw] text-white" />
      ),
      path: "/",
      action: handleHomeClick,
    },
    {
      label: "About Us",
      icon: (
        <Info className="w-[5vw] h-[5vw] md:w-[1.2vw] md:h-[1.2vw] text-white" />
      ),
      path: "/", // still go to “/”
      action: handleAboutClick, // ⬅ EXTRA: callback to fire after/ instead of navigation
    },
    {
      label: "Services",
      icon: (
        <Hammer className="w-[5vw] h-[5vw] md:w-[1.2vw] md:h-[1.2vw] text-white" />
      ),
      path: "/service-page",
    },
    {
      label: "Contact Us",
      icon: (
        <Phone className="w-[5vw] h-[5vw] md:w-[1.2vw] md:h-[1.2vw] text-white" />
      ),
      path: "/newContactus",
    },
  ];

  return (
    <>
      <header>
        <div
          style={{ boxShadow: "0px 2px 4px" }}
          className="flex justify-between items-center w-full px-2 py-2"
        >
          {/* Logo on the left */}
          <Link
            to={
              location.pathname === "/LoginPage" ||
              location.pathname === "/signUp"
                ? "#"
                : "/"
            }
          >
            <img
              src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/logo-navbar-compressed.png"
              alt="logo"
              className="ml-[10%] h-[20%]"
            />
          </Link>

          {/* Right side - Login & Menu */}
          <div className="flex items-center mr-[2%]">
            {location.pathname === "/" && (
              <div
                onClick={() => navigate("/LoginPage")}
                className="bg-[#21A6E9] flex py-[5px] rounded-full pr-[6px] pl-[18px] cursor-pointer"
              >
                <button className="font-satoshi font-[400] text-[18px] leading-[33.6px] pr-[15px] text-[#FFFFFF]">
                  Log In
                </button>
                <img
                  src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg"
                  className="h-[40px] w-[40px] pl-[4%]"
                  alt="arrow"
                />
              </div>
            )}

              <button
                onClick={() => setOpen(true)}
                className=" p-2 z-50 relative"
              >
                <Menu className="text-[#21A6E9] h-[30px] w-[30px]" />
              </button>

          </div>
        </div>
        <div className="relative z-50">
          {/* Hamburger Button */}

          {/* Slide-in Menu */}
          <AnimatePresence>
            {open && (
              <motion.div
                initial={{ x: "100%" }}
                animate={{ x: 0 }}
                exit={{ x: "100%" }}
                transition={{ type: "spring", stiffness: 300, damping: 30 }}
                className="fixed top-0 right-0 h-full md:w-[30%] sm:w-[40%] bg-[#35bbffed] shadow-lg p-6 flex flex-col items-start space-y-6 z-40"
              >
                <button
                  onClick={() => setOpen(false)}
                  className="self-end mb-4 text-white"
                >
                  <X className="h-[30px] w-[30px]" />
                </button>

                {menuItems.map((item, index) => (
                  <Link
                    key={index}
                    to={item.path}
                    className="flex items-center gap-3 text-white font-satoshi text-[5vw] md:text-[1.5vw] font-medium"
                    onClick={(e) => {
                      setOpen(false); // close your menu drawer

                      if (item.action) {
                        // If you’re *already* on the home page,
                        // we don’t want a full page refresh:
                        e.preventDefault();

                        // Let React Router update the URL hash (optional but nice)
                        // window.history.replaceState(null, '', '/#about');

                        item.action(); // smooth‑scroll
                      }
                    }}
                  >
                    {item.icon}
                    {item.label}
                  </Link>
                ))}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </header>
    </>
  );
}

export default Navbar;
